<!-- 注册sp2 -->
<template>
    <div class="sp1">
        <div class="sp1-main">
            <div class="sp1-title">———————————— 注册企业账户 ————————————</div>
            <el-form :model="step2Form" ref="step2Form" label-width="150px">
                <el-form-item label="公司网址">
                    <el-input v-model.trim="step2Form.Website" v-filter-special-char="step2Form.Website" maxlength="200"></el-input>
                </el-form-item>
                <div class="">
                    <!--1-->
                    <template v-if="shopType == 1">
                        <el-form-item label="服务提供项目">
                            <el-checkbox-group v-model="type1.data2">
                                <el-checkbox v-for="item in ServiceItem" :label="item.TValue" name="type" :key="item.TKey"></el-checkbox>
                            </el-checkbox-group>
                            <el-input placeholder="其他" v-model.trim="type1.data3"></el-input>
                        </el-form-item>
                    </template>
                    <!--2-->
                    <template v-else-if="shopType == 2">
                        <el-form-item label="经营类别">
                            <el-checkbox-group v-model="type2.data2">
                                <el-checkbox v-for="item in BusinessItem" :label="item.TValue" name="type" :key="item.TKey"></el-checkbox>
                            </el-checkbox-group>
                            <el-input placeholder="其他" v-model.trim="type2.data3"></el-input>
                        </el-form-item>

                        <el-form-item label="经营车型">
                            <div class="carType-ctn" @click="showDialog(2)">
                                <div class="carTypeItem" v-for="(item, index) in type2.data4" :key="index">
                                    {{ item.Cn }}
                                    <i class="el-icon-circle-close-outline car-del-btn" @click.stop="delCar(2, index)"></i>
                                </div>
                            </div>
                        </el-form-item>
                    </template>
                    <!--3-->
                    <template v-else-if="shopType == 3">
                        <el-form-item label="经营类别">
                            <el-checkbox-group v-model="type3.data2">
                                <el-checkbox v-for="item in BusinessTypeB" :label="item.TValue" name="type" :key="item.TKey"></el-checkbox>
                            </el-checkbox-group>
                        </el-form-item>

                        <el-form-item label="配件品种<牌>">
                            <el-input v-model.trim="type3.data3" v-filter-special-char="type3.data3"></el-input>
                        </el-form-item>

                        <el-form-item label="适用车型">
                            <div class="carType-ctn" @click="showDialog(3)">
                                <div class="carTypeItem" v-for="(item, index) in type3.data4" :key="item.Id">
                                    {{ item.Cn }}
                                    <i class="el-icon-circle-close-outline car-del-btn" @click.stop="delCar(3, index)"></i>
                                </div>
                            </div>
                        </el-form-item>
                    </template>
                    <!--4-->
                    <template v-else-if="shopType == 4">
                        <el-form-item label="物流类型">
                            <el-checkbox-group v-model="type4.data2">
                                <el-checkbox v-for="item in LogisticsType" :label="item.TValue" name="type" :key="item.TKey"></el-checkbox>
                            </el-checkbox-group>
                        </el-form-item>
                        <el-form-item label="优势路线">
                            <div class="express-line">
                                A
                                <input type="text" class="input-underline" v-model.trim="type4.data3.A.start" v-filter-special-char="type4.data3.A.start" />
                                至
                                <input type="text" class="input-underline" v-model.trim="type4.data3.A.end" v-filter-special-char="type4.data3.A.end" />
                                路程耗时
                                <input type="number" class="input-underline" v-model.trim="type4.data3.A.time" v-filter-special-char.trim="type4.data3.A.time" />
                                小时
                            </div>
                            <div class="express-line">
                                B
                                <input type="text" class="input-underline" v-model.trim="type4.data3.B.start" v-filter-special-char="type4.data3.B.start" />
                                至
                                <input type="text" class="input-underline" v-model.trim="type4.data3.B.end" v-filter-special-char="type4.data3.B.end" />
                                路程耗时
                                <input type="number" class="input-underline" v-model.trim="type4.data3.B.time" v-filter-special-char="type4.data3.B.time" />
                                小时
                            </div>
                            <div class="express-line">
                                C
                                <input type="text" class="input-underline" v-model.trim="type4.data3.C.start" v-filter-special-char="type4.data3.C.start" />
                                至
                                <input type="text" class="input-underline" v-model.trim="type4.data3.C.end" v-filter-special-char="type4.data3.C.end" />
                                路程耗时
                                <input type="number" class="input-underline" v-model.trim="type4.data3.C.time" v-filter-special-char="type4.data3.C.time" />
                                小时
                            </div>
                        </el-form-item>
                    </template>
                    <!--5-->
                    <template v-else-if="shopType == 5">
                        <el-form-item label="资质说明">
                            <div>汽修经验<input type="number" v-model.trim="type5.data2" class="input-normal" v-filter-special-char="type5.data2" />年</div>
                            <div>汽配经验<input type="number" v-model.trim="type5.data3" class="input-normal" v-filter-special-char="type5.data3" />年</div>
                            <div>企业经营<input type="number" v-model.trim="type5.data4" class="input-normal" v-filter-special-char="type5.data4" />年</div>
                            <div>企业员工<input type="number" v-model.trim="type5.data5" class="input-underline" v-filter-special-char="type5.data5" />人</div>
                        </el-form-item>
                    </template>
                    <!--6-->
                    <template v-else-if="shopType == 6">
                        <el-form-item label="合作类型">
                            <el-radio-group v-model="type6.data2" @change="type6Change">
                                <el-radio label="我是广告主"></el-radio>
                                <el-radio label="我是广告商"></el-radio>
                            </el-radio-group>
                            <div v-if="type6.data2 == '我是广告主'">
                                <p>
                                    投放广告类型：
                                    <el-select placeholder="请选择投放广告类型" v-model="type6.data3" size="mini">
                                        <el-option :label="item.TValue" :value="item.TKey" v-for="item in CAdvType" :key="item.TKey"></el-option>
                                    </el-select>
                                </p>
                                <p>
                                    投放产品类型：
                                    <el-select placeholder="请选择投放产品类型" v-model="type6.data4" size="mini">
                                        <el-option :label="item.TValue" :value="item.TKey" v-for="item in CProductType" :key="item.TKey"></el-option>
                                    </el-select>
                                </p>
                                <p>
                                    投放产品名称：
                                    <input type="text" class="input-underline" v-model.trim="type6.data5" v-filter-special-char.trim="type6.data5" />
                                </p>
                            </div>
                            <div v-else>
                                <p>
                                    媒体类型：
                                    <el-select placeholder="请选择媒体类型" v-model="type6.data3" size="mini">
                                        <el-option :label="item.TValue" :value="item.TKey" v-for="item in BMediaType" :key="item.key"></el-option>
                                    </el-select>
                                </p>
                                <p>
                                    广告类型：
                                    <el-select placeholder="请选择广告类型" v-model="type6.data4" size="mini">
                                        <el-option :label="item.TValue" :value="item.TKey" v-for="item in BAdvType" :key="item.key"></el-option>
                                    </el-select>
                                </p>
                            </div>
                        </el-form-item>
                    </template>
                    <!--7-->
                    <template v-else>
                        <el-form-item label="合作意向">
                            <el-input v-model="type7.data2"></el-input>
                        </el-form-item>
                    </template>
                </div>
                <el-form-item label="选择证件类型" prop="data1">
                    <el-select placeholder="请选择证件类型" v-model="step2Form.data1">
                        <el-option :label="item.TValue" :value="item.TValue" v-for="item in CertType" :key="item.TKey"></el-option>
                    </el-select>
                </el-form-item>
                <div class="">
                    <el-form-item label="上传证件">
                        <uploadFile type="EntpCredentials" @uploadSuccess="uploadPaperSuccess"></uploadFile>
                    </el-form-item>
                    <el-form-item label="上传营业执照">
                        <uploadFile type="EntpCredentials" @uploadSuccess="uploadLicenseSuccess"></uploadFile>
                    </el-form-item>
                </div>
                <el-form-item>
                    <el-button @click="gotoPrev()">上一步</el-button>
                    <el-button class="btn-primary" @click="submitForm()">下一步</el-button>
                </el-form-item>
            </el-form>
        </div>
        <el-dialog :close-on-click-modal="false" title="选择品牌" :visible.sync="dialogVisible" width="850px">
            <chooseCarType @chooseCar="chooseCar"></chooseCarType>
        </el-dialog>
    </div>
</template>
<script>
import chooseCarType from '@/components/registered/chooseCarType.vue';
import uploadFile from '@/components/common/uploadFile.vue';
import mixin from '@/mixins/mixin';
export default {
    mixins: [mixin],
    name: '',
    components: {
        chooseCarType,
        uploadFile
    },
    data() {
        return {
            multiple: false,
            CertType: [], // 证件类型
            chooseCarTypeIndex: 2, // 当前选择车型是要填进哪个
            dialogVisible: false, // dialog显隐
            shopType: 6,
            type1: {
                data2: [],
                data3: ''
            },
            type2: {
                data2: [],
                data3: '',
                data4: []
            },
            type3: {
                data2: [],
                data3: '',
                data4: []
            },
            type4: {
                data2: [],
                data3: {
                    A: {
                        start: '',
                        end: '',
                        time: ''
                    },
                    B: {
                        start: '',
                        end: '',
                        time: ''
                    },
                    C: {
                        start: '',
                        end: '',
                        time: ''
                    }
                }
            },
            type5: {
                data2: '',
                data3: '',
                data4: '',
                data5: ''
            },
            type6: {
                data2: '我是广告主',
                data3: '',
                data4: '',
                data5: ''
            },
            type7: {
                data2: ''
            },
            step2Form: {
                Source: 'entp_pc_client',
                PaperworkPic: [], // 缓存证件信息
                licensePic: [], // 缓存营业执照
                data1: '', // 证件类型
                Website: '',
                CardUrl: '', //个人名片图片链接
                LicenseUrl: '' // 营业执照图片链接
            },
            rules: {
                Website: [{ required: false, message: '请输入公司网址', trigger: 'blur' }],
                data1: [{ required: true, message: '请选择证件类型', trigger: 'change' }],
                CardUrl: [{ required: true, message: '请上传证件', trigger: 'change' }],
                LicenseUrl: [{ required: true, message: '请上传营业执照', trigger: 'change' }]
            },
            CAdvType: [], // 投放广告类型
            CProductType: [], // 投放产品类型
            BMediaType: [], // 媒体类型
            BAdvType: [], // 广告类型
            ServiceItem: [], // 服务类型
            BusinessItem: [], //经营类别
            BusinessTypeB: [], //经营类别2
            LogisticsType: [] //物流类型
        };
    },
    mounted() {
        let shopType = this.$route.query.shopType;
        this.shopType = shopType;
        let shopTypeStorage = this.$util.getLocalStorage('shopType');
        if (shopTypeStorage) {
            this.step2Form = this.$util.getLocalStorage('step2Form');
            if (shopType == shopTypeStorage) {
                this['type' + shopTypeStorage] = this.$util.getLocalStorage('dynamic');
            }
        }
        this.getConfigData(`CertType,CAdvType,CProductType,BMediaType,BAdvType,ServiceItem,BusinessItem,BusinessType-B,LogisticsType`);
    },
    methods: {
        // 上传前校验
        beforeAvatarUpload(file) {
            return this.$util.uploadCheck(file);
        },
        // 配置
        getConfigData(typeCode) {
            this.$util.getConfigData(typeCode).then(res => {
                for (let i = 0; i < res.length; i++) {
                    if (res[i].TypeCode == 'CertType') {
                        this.CertType.push(res[i]);
                    } else if (res[i].TypeCode == 'CAdvType') {
                        this.CAdvType.push(res[i]);
                    } else if (res[i].TypeCode == 'CProductType') {
                        this.CProductType.push(res[i]);
                    } else if (res[i].TypeCode == 'BMediaType') {
                        this.BMediaType.push(res[i]);
                    } else if (res[i].TypeCode == 'BAdvType') {
                        this.BAdvType.push(res[i]);
                    } else if (res[i].TypeCode == 'ServiceItem') {
                        this.ServiceItem.push(res[i]);
                    } else if (res[i].TypeCode == 'BusinessItem') {
                        this.BusinessItem.push(res[i]);
                    } else if (res[i].TypeCode == 'BusinessType-B') {
                        this.BusinessTypeB.push(res[i]);
                    } else if (res[i].TypeCode == 'LogisticsType') {
                        this.LogisticsType.push(res[i]);
                    }
                }
                // this[typeCode] = data
            });
        },
        // 显示Dialog
        showDialog(type) {
            this.chooseCarTypeIndex = type;
            this.dialogVisible = true;
        },
        // 选中的车型填入表单
        chooseCar(data) {
            let type = this.chooseCarTypeIndex;
            if (type == 2) {
                this.type2.data4.push(data);
            } else if (type == 3) {
                this.type3.data4.push(data);
            }
            this.dialogVisible = false;
        },
        // 删除车型
        delCar(type, index) {
            if (type == 2) {
                let _type2Data4 = this.type2.data4;
                _type2Data4.splice(index, 1);
                this.$set(this.type2, 'data4', _type2Data4);
            } else if (type == 3) {
                let _type3Data4 = this.type3.data4;
                _type3Data4.splice(index, 1);
                this.$set(this.type3, 'data4', _type3Data4);
            }
        },
        // 提交数据
        submitForm() {
            // 无法调用表单验证的字段要先自行验证一下
            let _data = this['type' + this.shopType];

            //                 if(this.shopType == 1){
            //                     if (this.type1.data2 == ''){
            //                         this.$util.warningMsg('请填写服务提供项目')
            //                         return
            //                     }
            //                 }
            //                 else if (this.shopType == 2){
            //                     if ( this.type2.data2 ==''){
            //                         this.$util.warningMsg('请填写经营类别')
            //                         return
            //                     }
            //                     if (this.type2.data4 ==''){
            //                         this.$util.warningMsg('请填写经营车型')
            //                         return
            //                     }
            //                 }
            //                 else {
            //                     for(let key in _data){
            //                         let valueType = Object.prototype.toString.apply(_data[key])
            //                         if (valueType == '[object Array]'){
            //                             if(!_data[key][0]){
            //                                 this.$util.warningMsg('请填写必填字段喔')
            //                                 return
            //                             }
            //                         }
            //                         else if (valueType == '[object Object]'){
            // //
            //                         }
            //                         else if (valueType == '[object String]'){
            //                             if(!_data[key]){
            //                                 this.$util.warningMsg('请填写必填字段喔')
            //                                 return
            //                             }
            //                         }
            //                     }
            //                 }
            //                 if (!this.step2Form.CardUrl || !this.step2Form.LicenseUrl){
            //                     this.$util.warningMsg('请上传证件')
            //                     return
            //                 }
            this.$refs.step2Form.validate(valid => {
                if (valid) {
                    let _data = this['type' + this.shopType];
                    let sp1Data = this.$util.getLocalStorage('sp1Form');
                    if (!sp1Data) {
                        this.$util.warningMsg('上传数据不完整');
                        return;
                    }
                    let finalData = Object.assign(sp1Data, this.step2Form, _data);
                    // 合并处理要提交的数据
                    for (let key in finalData) {
                        let valueType = Object.prototype.toString.apply(_data[key]);
                        if (valueType == '[object Array]' || valueType == '[object Object]') {
                            finalData[key] = JSON.stringify(_data[key]);
                        }
                    }
                    // 删除无用字段
                    delete finalData.PaperworkPic;
                    delete finalData.licensePic;
                    delete finalData.agree;
                    delete finalData.code;
                    delete finalData.addressLocal;
                    delete finalData.shopTypeLocal;
                    this.$util
                        .axiosPost({
                            url: '/api/EntpPromotion/RegisteredEntpAccount',
                            // data:this.$util.parseParam(finalData)
                            data: finalData
                        })
                        .then(res => {
                            if (res.data) {
                                this.$util.clearLocalStorage('sp1Form');
                                this.$util.clearLocalStorage('step2Form');
                                this.$util.clearLocalStorage('shopType');
                                this.$util.clearLocalStorage('dynamic');
                                this.$router.push('/registered/step3');
                            } else {
                                this.$util.warningMsg(res.errmsg);
                            }
                        })
                        .catch(() => {});
                } else {
                    this.$util.warningMsg('请填写必填字段喔');
                    return false;
                }
            });
        },
        // 上传证件照成功回调
        uploadPaperSuccess(res) {
            this.step2Form.CardUrl = res;
        },
        // 上传营业执照成功回调
        uploadLicenseSuccess(res) {
            this.step2Form.LicenseUrl = res;
        },
        // 跳转上一页
        gotoPrev() {
            // let _dynamic = this['type'+this.shopType];
            // let _step2Form = this.step2Form;
            // let _shopType = this.shopType;
            // this.$util.setLocalStorage('step2Form',_step2Form)
            // this.$util.setLocalStorage('shopType',_shopType)
            // this.$util.setLocalStorage('dynamic',_dynamic)
            this.$router.push('/registered/step1');
        },
        // type6 切换时清空
        type6Change() {
            this.type6.data3 = '';
            this.type6.data4 = '';
            // this.type6.data5 = ''  // todo 这里有bug 要修一下
        }
    }
};
</script>
<style lang="less" scoped>
.car-del-btn {
    cursor: pointer;
}
.carType-ctn {
    border: 1px solid #dcdfe6;
    border-radius: 5px;
    width: 550px;
    min-height: 40px;
    padding: 10px;
    display: flex;
    align-items: center;
}
.carTypeItem {
    padding: 0 5px;
    height: 24px;
    line-height: 24px;
    border: 1px solid @theme;
    color: @theme;
    margin-right: 10px;
}
.sp1-title {
    text-align: center;
    font-size: @font-lg;
    margin-bottom: 35px;
}
.sp1-main {
    padding-top: 100px;
    max-width: 700px;
    margin: 0 auto 50px;
}
.input-normal {
    border: 1px solid #dcdfe6;
    line-height: 24px;
    border-radius: 5px;
    margin: 0 5px;
}
.input-underline {
    margin: 0 5px;
    border: none;
    border-bottom: 1px solid @border4Color;
}
</style>
<style lang="less">
.area-select .area-selected-trigger {
    padding: 0 20px;
    line-height: 30px;
}
.area-select-wrap .area-select {
    margin-left: 0px !important;
    margin-right: 10px;
}
.company-name {
}
.express-line {
    input {
        width: 60px;
    }
}
.small-input {
    border: none;
    border: 1px solid @border4Color;
}
.is-required {
    .el-form-item__label::before {
        content: '*';
        color: #f56c6c;
        margin-right: 4px;
    }
}
</style>
